<template>
  <div :style="{ height: gao + 'px', width: '100%' }">
    <hhead></hhead>
    <nnav></nnav>
    <!-- 结算单 -->
    <iframe v-bind:src="contents"></iframe>

    <!-- 报告 -->

    <!-- <iframe
      src="https://sim.jeesit.com/liangqi_view/inter.htm?userCode=1&amp;userPwd=c4ca4238a0b923820dcc509a6f75849b&amp;userType=1&amp;view=&amp;linkTo=1"
      style="width: 100%;height: calc(100% - 50px);margin-top: 45px;"
    ></iframe> -->
  </div>
</template>
<script>
import hhead from '../../../../components/header/index';
import nnav from '../../../../components/nav/index';
export default {
  name: 'vview',
  components: { hhead, nnav },
  data() {
    return {
      gao: document.documentElement.clientHeight,
      id: '',
      userPwd: '',
      linkTo: '',
      contents: '',
      code: '',
      type: '',
      url: '',
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.userPwd = this.$route.query.userPwd;
    this.linkTo = this.$route.query.linkTo;
    this.code = this.$route.query.userCode;
    this.type = this.$route.query.userType;
    this.url = this.$route.query.url;

    console.log(this.linkTo);
    if (this.linkTo == '2') {
      this.contents = `https://${this.url}/liangqi_view/inter.htm?userCode=${this.code}&userPwd=${this.userPwd}&userType=${this.type}&view=&linkTo=2`;
      // console.log();
    }
    if (this.linkTo == '1') {
      this.contents = `https://${this.url}/liangqi_view/inter.htm?userCode=${this.code}&userPwd=${this.userPwd}&userType=${this.type}&view=&linkTo=1`;
    }
  },
};
</script>
<style>
iframe {
  width: 99.7%;
  min-width: 980px;
  margin-top: -5px;
  height: calc(100% - 50px);
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/view/user/eval_jees/view/index.vue